import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { RadioButton } from "primereact/radiobutton";
//components
import Modal from "../../../components/modal/Modal";
import CreditCard from "../../../components/payment/CreditCard";
import ModalClientData from "../../../components/payment/ModalClientData";
//services
import { getUserCreditCard } from "../../../services/ClientArea/getUserCreditCard";
import { postUserPaymentMethod } from "../../../services/ClientArea/postUserPaymentMethod";
import { toast } from "react-toastify";
import UserCards from "../../../components/payment/UserCards";
import { queryClient } from "../../../utils/queryClient";

const UserCreditCard = () => {
  const [visible, setVisible] = useState(false);
  const [baseDataForm, setBaseDataForm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeIndexModal, setActiveIndexModal] = useState(0);
  const [creditCardClient, setCreditCardClient] = useState(null);
  const [visibleModalCreditCard, setVisibleModalCreditCard] = useState(false);
  const [cardState, setCardState] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });

  const { data, isLoading } = useQuery({
    queryKey: ["UserCreditCard"],
    queryFn: () => getUserCreditCard(),
    retry: false,
    // enabled: !!permissions?.includes("1"),
  });

  const { mutateAsync: postUserPaymentMethodFn } = useMutation({
    mutationFn: postUserPaymentMethod,
    onSuccess(res, variables) {
      queryClient.setQueryData(["UserCreditCard"], (data) => {
        if (variables.remove_card) {
          // Se está removendo o cartão ativo, desativar todos os cartões
          return data.map((item) => ({ ...item, active: 0 }));
        } else if (variables.card_id) {
          console.log(variables);
          const updatedData = data.map((item) => {
            if (item.id === variables.card_id) {
              return { ...item, active: 1 };
            }
            if (item.active === 1) {
              return { ...item, active: 0 };
            }
            return item;
          });

          // console.log(updatedData);
          return updatedData;
        } else {
          return [
            ...data,
            {
              ...variables,
              id: res.success.card_id, // Corrigido "suceess" para "success"
            },
          ];
        }
      });
    },
  });

  const handleInputChange = (name, value) => {
    if (name === "expiry") {
      const [month, day] = value.split("/");
      if (month && (parseInt(month, 10) > 12 || parseInt(month, 10) < 1)) {
        setCardState((prevState) => ({
          ...prevState,
          expiry: "",
        }));
        return;
      } else {
        setCardState((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setCardState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleInputFocus = (name) => {
    setCardState((prev) => ({ ...prev, focus: name }));
  };

  const handleSelectCard = async (card) => {
    setLoading(true);
    const notification = toast.loading("Aguarde...");
    const activeCard = data?.find(c => c.active === 1);
    const isRemovingActiveCard = activeCard && card.id === activeCard.id;
    const requestData = isRemovingActiveCard 
      ? { remove_card: true }
      : { card_id: card.id };
    try {
      await postUserPaymentMethodFn(requestData);
      setLoading(false);
      
      const successMessage = isRemovingActiveCard 
        ? "Cartão de cobrança removido com sucesso!"
        : "Cartão de cobrança alterado com sucesso!";
        
      toast.update(notification, {
        render: successMessage,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      setLoading(false);
      
      const errorMessage = isRemovingActiveCard
        ? "Não foi possível remover o cartão de cobrança!"
        : "Não foi possível alterar o cartão de cobrança!";
        
      toast.update(notification, {
        render: errorMessage,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    const notification = toast.loading("Aguarde...");
    const [exp_month, exp_year] = cardState.expiry.split("/");
    const data = {
      billing_address: creditCardClient.address,
      card_number: cardState.card_number,
      holder_name: cardState.name,
      exp_month: exp_month,
      exp_year: exp_year,
      cvv: cardState.cvc,
    };
    try {
      const response = await postUserPaymentMethodFn(data);
      console.log(response);
      setVisible(false);
      setLoading(false);
      toast.update(notification, {
        render: "Cartão cadastrado com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      setLoading(false);
      toast.update(notification, {
        render: "Não foi possível cadastrar o cartão!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  return (
    <>
      <div className="row justify-content-center text-center">
        <h3>Cartões cadastrados</h3>
        <h4>Segue abaixo os cartões cadastrados para cobrança</h4>
        {isLoading ? (
          <Skeleton width="100%" height="400px" />
        ) : (
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <UserCards
                cards={data}
                handleSelectCard={handleSelectCard}
                loading={loading}
              />
              <div
                className={`card-payment-method border rounded d-flex justify-content-start align-items-center p-3 my-2 ${
                  loading ? "disabled" : ""
                }`}
                onClick={() => !loading && setVisible(true)}
                style={{
                  pointerEvents: loading ? "none" : "auto",
                  opacity: loading ? 0.6 : 1,
                }}
              >
                <RadioButton
                  name="card"
                  value={"cardInstallment"}
                  onChange={(e) => !loading && setVisible(true)}
                  disabled={loading}
                />
                <i className={`fa-regular fa-credit-card mx-3`}></i>
                <h5 className="mt-2">Adicionar Cartão</h5>
              </div>
            </div>
          </div>
        )}
      </div>
      <Modal
        visible={visible}
        onHide={() => setVisible(false)}
        dynamicTitle="Adicionar cartão"
      >
        <CreditCard
          state={cardState}
          handleInputChange={handleInputChange}
          handleInputFocus={handleInputFocus}
          onClickData={() => {
            setVisibleModalCreditCard(true);
            setActiveIndexModal(0);
          }}
          onClickAddress={() => {
            setVisibleModalCreditCard(true);
            setActiveIndexModal(1);
          }}
          clientData={creditCardClient?.data && creditCardClient?.data}
          clientAddress={creditCardClient?.address && creditCardClient?.address}
        />
        <div className="d-flex justify-content-center">
          <Button
            rounded
            label="Salvar"
            icon="fa-solid fa-check"
            loading={loading}
            onClick={() => handleSubmit()}
          />
        </div>
      </Modal>
      <ModalClientData
        baseDataForm={baseDataForm}
        activeIndex={activeIndexModal}
        visible={visibleModalCreditCard}
        creditCardClient={creditCardClient}
        setActiveIndex={setActiveIndexModal}
        setVisible={setVisibleModalCreditCard}
        setCreditCardClient={setCreditCardClient}
      />
    </>
  );
};

export default UserCreditCard;
